import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useSession } from '@/lib/auth/session';
import { readAccessToken } from '@/lib/auth/token';

/**
 * 로그인 문지기.
 *
 * <p><b>이것은 인가가 아니다.</b> 무엇을 볼 수 있는지는 서버가 매 요청 판정한다
 * (외부는 메뉴 권한이 아니라 `vendor_id`·`site_id` 데이터 경계로 갈린다 — DOC-82 §3-5).
 * 여기서 하는 일은 로그인하지 않은 사람을 로그인 화면으로 보내는 UX 뿐이다.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const location = useLocation();
  const hasToken = readAccessToken() !== null;
  const session = useSession();

  if (!hasToken) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  // 토큰은 있는데 아직 확인 전. 화면을 깜빡이지 않게 자리를 지킨다.
  if (session.isPending) {
    return <div className="p-6 text-ui-sm" style={{ color: 'var(--text-muted)' }}>불러오는 중입니다…</div>;
  }

  if (session.isError) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
